export const URLS = {
  auth: '/auth',
  signIn: '/auth/signin',
  signUp: '/auth/signup',
  phone: '/auth/phone',
  newPassword: '/auth/newpassword',
  requestSent: '/auth/requestsent',
  resetPassword: '/auth/resetpassword',
  home: '/',
  allYieldBearingAssets: '/yieldbearingassets',
  invest: '/invest',
  allTransactions: '/transactions',
  portfolio: '/portfolio',
  allNews: '/news',
  allMarketData: '/market',
  trade: '/trade',
};

// Pre-authentication routes
export const preAuthRoutes = [
  '/auth',
  '/auth/signin',
  '/auth/signup',
  '/auth/phone',
  '/auth/newpassword',
  '/auth/requestsent',
  '/auth/resetpassword',
];

type assetImage = {
  [key: string]: string;
};

export const NETWORKS_IMAGES: assetImage = {
  BSC: '/images/bnb.png',
};

export const ASSETS_IMAGES: assetImage = {
  usdc: '/images/svg/usdc.svg',
  dai: '/images/svg/dai.svg',
  eth: '/images/svg/eth.svg',
  weth: '/images/svg/eth.svg',
  tusd: '/images/svg/tusd.svg',
  usdt: '/images/svg/usdt.svg',
  matic: '/images/svg/matic.svg',
  bitcoin: '/images/svg/bitcoin.svg',
  wmatic: '/images/wmactic.png',
  bnb: '/images/svg/bnb.svg',
  vault: '/images/vault_.png',
  onboarding: '/images/onboarding_2.png',
  clock: '/images/clock_.png',
  syntheticPool: '/images/USDC-DAI-wBNB.svg',
};

export const EMAIL_FORM_VALIDATIONS = {
  mustContainAtSign: (value: string) =>
    EMAIL_RULES.mustContainAtSign.value.test(value) ||
    EMAIL_RULES.mustContainAtSign.message,
  mustBeValidEmail: (value: string) =>
    EMAIL_RULES.mustBeValidEmail.value.test(value) ||
    EMAIL_RULES.mustBeValidEmail.message,
};

export const PASSWORD_FORM_VALIDATIONS = {
  lowercase: (value: string) =>
    PASSWORD_RULES.lowercase.value.test(value) || '',
  uppercase: (value: string) =>
    PASSWORD_RULES.uppercase.value.test(value) || '',
  nineCharacters: (value: string) =>
    PASSWORD_RULES.nineCharacters.value.test(value) || '',
  number: (value: string) => PASSWORD_RULES.number.value.test(value) || '',
};

export const EMAIL_RULES = {
  mustContainAtSign: {
    value: new RegExp('@'),
    message: "Don't forget to add the '@'",
  },
  mustBeValidEmail: {
    value: new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/),
    message: 'Enter a valid email address',
  },
};

export const PASSWORD_RULES = {
  uppercase: {
    title: '1 uppercase letter',
    message: 'Your password must contain 1 uppercase letter',
    value: new RegExp(/^(?=.*[A-Z])/),
  },
  nineCharacters: {
    title: '9 characters',
    message: 'Your password must contain 9 characters',
    value: new RegExp(/.{9,}/),
  },
  lowercase: {
    title: '1 lowercase letter',
    message: 'Your password must contain 1 lowercase letter',
    value: new RegExp(/^(?=.*[a-z])/),
  },
  number: {
    title: '1 number',
    message: 'Your password must contain 1 number',
    value: new RegExp(/^(?=.*\d)/),
  },
};

export const DIGIT_RULE = new RegExp(/^\d+$/);
export const ONE_NUMBER_RULE = new RegExp(/[0-9]{1}/);

export const DAI_CONTRACT_ADDRESS =
  '0x6B175474E89094C44Da98b954EedeAC495271d0F';
export const USDC_CONTRACT_ADDRESS =
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';
export const gasLimit = {
  // withdraw: {
  //     normal: {
  //         sameToken: 500000,
  //         differentToken: 900000,
  //     },
  //     synthetic: {
  //         sameToken: 600000,
  //         differentToken: 1000000,
  //     },
  // },
  deposit: {
    normal: 700000,
    synthetic: 900000,
  },
  depositSynthetic: {
    normal: 700000,
    synthetic: 900000,
  },
  withdraw: {
    sameToken: 500000,
    differentToken: 900000,
    normal: {
      sameToken: 500000,
      differentToken: 900000,
    },
    synthetic: {
      sameToken: 600000,
      differentToken: 1000000,
    },
  },
  depositDAI: 700000,
  depositUSDC: 700000,
};

export const NETWORKS: { [chainId: number]: string } = {
  97: 'Binance Smart Chain (BSC) Testnet',
  56: 'Binance Smart Chain (BSC)',
};

export const WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/g;

export const TOKEN_NAME: { [token: string]: string } = {
  usdc: 'US Dollar Coin',
  dai: 'DAI Token',
};

export const countryCodeRegex = /\(([^)]+)\)/;

export const ResendOTPIntervalTimeout = 30;

// api
export const LLAMA_POOL_URL = `https://yields.llama.fi/poolsEnriched?pool=`;
